import { useState } from "react";
import AppContext from "./AppContext";

import useLoading from "../Hooks/useLoadingModal";
import useMessageModal from "../Hooks/useMessageModal";

import LoadingModal from "./../Components/Modal/LoadingModal";
import MessageModal from "./../Components/Modal/MessageModal";
import useIpLocation from "./../Hooks/useIpLocation";

function Provider({ children }) {
  const [sideBarIsOpen, setSideBarIsOpen] = useState(false);
  const loadingProps = useLoading();
  const messageProps = useMessageModal();
  const ipLocationProps = useIpLocation();

  const [member, setMember] = useState(null);
  const [token, setToken] = useState(null);

  return (
    <AppContext.Provider
      value={{
        loadingProps,
        messageProps,
        ipLocationProps,
        sideBarIsOpen,
        setSideBarIsOpen,
        member,
        setMember,
        token,
        setToken,
      }}
    >
      {children}
      <LoadingModal {...loadingProps} />
      <MessageModal {...messageProps} />
    </AppContext.Provider>
  );
}

export default Provider;
